import {
  createStore as reduxCreateStore,
  applyMiddleware,
  compose,
} from 'redux'
import createSagaMiddleware from 'redux-saga'
import { routerMiddleware } from 'react-router-redux'
import { persistStore } from 'redux-persist'
import rootReducer from '../modules'
import allSagas from '../sagas'

const composeEnhancers =
  (typeof window !== 'undefined' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose

const createStore = history => {
  const sagaMiddleware = createSagaMiddleware()
  const middleware = [routerMiddleware(history), sagaMiddleware]

  const store = reduxCreateStore(
    rootReducer,
    composeEnhancers(applyMiddleware(...middleware)),
  )

  const persistor = persistStore(store)

  sagaMiddleware.run(allSagas)

  return { store, persistor }
}

export default createStore



// WEBPACK FOOTER //
// ./src/store/createStore.js